import {
  differenceInCalendarDays,
  differenceInMinutes,
  parseISO,
  startOfDay,
  subDays,
  subMinutes,
} from 'date-fns';
import { Booking } from '../models/entities/booking';
import { Room } from '../models/entities/room';

const DEFAULT_OPENING_MINUTES = 6 * 60;

export class BookingLastOccupiedDayHelper {
  static lastOccupiedDayOf(booking: Booking, room: Room): Date {
    const start = parseISO(booking.start);
    const lastMinute = subMinutes(parseISO(booking.end), 1);
    const endsBeforeOpeningOfLaterDay =
      differenceInCalendarDays(lastMinute, start) > 0 &&
      differenceInMinutes(lastMinute, startOfDay(lastMinute)) <
        this.openingMinutesOfDay(room);

    return endsBeforeOpeningOfLaterDay ? subDays(lastMinute, 1) : lastMinute;
  }

  private static openingMinutesOfDay(room: Room): number {
    if (!room?.min_start) {
      return DEFAULT_OPENING_MINUTES;
    }
    const opening = new Date(room.min_start);
    return (
      opening.getHours() * 60 + opening.getMinutes() || DEFAULT_OPENING_MINUTES
    );
  }
}
